import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { KitComponent } from './createKitComponent';
import type { WriteRequestOptions } from '../requestOptions';

export const updateKitComponent = async (
  scope: RequestScope,
  id: number,
  data: Partial<KitComponent>,
  options: WriteRequestOptions
): Promise<EndpointResponse<KitComponent>> => {
  try {
    const response = await scopedApi(scope).patch<EndpointResponse<KitComponent>>(`/kit_component/${id}`, data, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
